export const fragmentEnded = new Event("fragmentEnded");
